import { render, staticRenderFns } from "./choseCourseSchoolBasePreviewGroup.vue?vue&type=template&id=615130d8&scoped=true&"
import script from "./choseCourseSchoolBasePreviewGroup.vue?vue&type=script&lang=js&"
export * from "./choseCourseSchoolBasePreviewGroup.vue?vue&type=script&lang=js&"
import style0 from "./choseCourseSchoolBasePreviewGroup.vue?vue&type=style&index=0&id=615130d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615130d8",
  null
  
)

export default component.exports